<template>

  <svg
    t="1639131974346"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4727"
    width="64"
    height="64"
  ><path d="M875.04759467 714.04748799a36.32878933 36.32878933 0 0 1-52.21034667 9.08765868l-272.54237866-204.95291734a63.635456 63.635456 0 0 0-76.58973868 0l-272.52053333 204.95291734a36.306944 36.306944 0 0 1-52.21034666-9.08765868c-12.582912-19.00544-10.76974933-44.19310933 4.36906666-61.16693332L448.495616 322.05482667a84.91281067 84.91281067 0 0 1 127.008768 0L870.63483733 652.85870933a50.331648 50.331648 0 0 1 4.41275734 61.16693334z" p-id="4728" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconArrowUp',
} as DefineComponent
</script>